import axiosConfig from './axiosConfig';

// List events
export const getEventList = async (queryParams = {}) => {
    try {
        const response = await axiosConfig.get('event', { params: queryParams });
        return response;
    } catch (error) {
        throw error;
    }
};

// Create event
export const createEvent = async (eventData) => {
    try {
        const response = await axiosConfig.post('event', eventData);
        return response;
    } catch (error) {
        throw error || 'Failed to create event';
    }
};

// Show event details
export const getEventDetails = async (id) => {
    try {
        const response = await axiosConfig.get(`event/${id}`);
        return response;
    } catch (error) {
        throw error;
    }
};

// Update event
export const updateEvent = async (id, eventData) => {
    try {
        const response = await axiosConfig.put(`event/${id}`, eventData);
        return response;
    } catch (error) {
        throw error || 'Failed to update event';
    }
};

// Delete event
export const deleteEvent = async (id) => {
    try {
        const response = await axiosConfig.delete(`event/${id}`);
        return response;
    } catch (error) {
        throw error || 'Failed to delete event';
    }
};